<ng-container [ngSwitch]="fieldType">
  <div *ngSwitchCase="'COMBO'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? (fieldValue | technicalTranslate) : ''" *ngIf="!dummyValueFlag">
      {{fieldValue ? (fieldValue | technicalTranslate) : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue | technicalTranslate) : ''" *ngIf="dummyValueFlag">
      {{dummyValue ? (dummyValue | technicalTranslate) : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'COMBOMULTISELECTCSV'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? (fieldValue | technicalTranslate) : ''" *ngIf="!dummyValueFlag">
      {{fieldValue ? (fieldValue | technicalTranslate) : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue | technicalTranslate) : ''" *ngIf="dummyValueFlag">
      {{dummyValue ? (dummyValue | technicalTranslate) : '-'}}
    </span>
  </div>
  
  <div *ngSwitchCase="'COMBOMULTISELECTENTERABLECSV'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue | technicalTranslate) : ''" *ngIf="!dummyValueFlag">
      {{fieldValue ? (fieldValue ) : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue ) : ''" *ngIf="dummyValueFlag">
      {{dummyValue ? (dummyValue ) : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'DATE'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? (fieldValue | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : ''"
      *ngIf="!dummyValueFlag">{{fieldValue ? (fieldValue | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : ''"
      *ngIf="dummyValueFlag">{{dummyValue ? (dummyValue | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'INPUT'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'TAG'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'MASKEDINPUT'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'NUMBERINPUT'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span  class="text-ellipses-w90Pcnt" [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'CURRENCYINPUT'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span  class="text-ellipses-w90Pcnt" [title]="fieldValue ? (fieldValue | CurrencyFormatter : (appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : ''" *ngIf="!dummyValueFlag">{{fieldValue ? (fieldValue | CurrencyFormatter : (appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : '-'}}
    </span>
    <span  class="text-ellipses-w90Pcnt" [title]="dummyValue ? (dummyValue | CurrencyFormatter : (appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : ''" *ngIf="dummyValueFlag">{{dummyValue ? (dummyValue | CurrencyFormatter : (appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'TEXTAREA'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag && fieldName!='Remark (optional)'">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span [title]="fieldValue ? fieldValue : ''" *ngIf="!dummyValueFlag && fieldName=='Remark (optional)'">{{fieldValue ? fieldValue : '-'}}
    </span>
    <span [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'TIME'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span  class="text-ellipses-w90Pcnt" [title]="fieldValue? (fieldValue | date : appMetadataHandler.GLOBAL_TIME_FORMAT_ANGULAR) : ''"
      *ngIf="!dummyValueFlag">{{fieldValue? (fieldValue | date : appMetadataHandler.GLOBAL_TIME_FORMAT_ANGULAR) : '-'}}
    </span>
    <span  class="text-ellipses-w90Pcnt" [title]="dummyValue? (dummyValue | date : appMetadataHandler.GLOBAL_TIME_FORMAT_ANGULAR) : ''"
      *ngIf="dummyValueFlag">{{dummyValue? (dummyValue | date : appMetadataHandler.GLOBAL_TIME_FORMAT_ANGULAR) : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'CHECKBOX'">
    <strong class="c-s-heading">{{fieldName | translate}}</strong>
    <span class="text-ellipses-w90Pcnt" [title]="fieldValue ? (fieldValue ? 'Yes' : 'No') : ''" *ngIf="!dummyValueFlag">{{fieldValue ? (fieldValue ? 'Yes' : 'No') : '-'}}
    </span>
    <span class="text-ellipses-w90Pcnt" [title]="dummyValue ? dummyValue : ''" *ngIf="dummyValueFlag">{{dummyValue ? dummyValue : '-'}}
    </span>
  </div>

  <div *ngSwitchCase="'BIGCHECKBOX'" class="bigcheckbox-width" [class.inputs-are-disabled]="true" [class.anchors-are-disabled]="true">
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <strong class="c-s-heading"> <label  nz-checkbox  [(ngModel)]="fieldValue">
          {{fieldName | translate}}
        </label> </strong>
      </nz-form-control>
    </nz-form-item>
  </div>

</ng-container>